import React, { useEffect, useState } from "react";
import DSSTextInput from "../../../../../ui/building-blocks/atoms/dss-textinput";
import DSSButton from "../../../../../ui/building-blocks/atoms/dss-button";
import Stepper from "../../../../../ui/building-blocks/organism/stepper/stepper";
import { useNavigate } from "react-router-dom";
import "./index.scss";
import { useDssContext } from "../../../../../DSSContext";
import DSSModal from "../../../../../ui/building-blocks/atoms/dss-modal";
import AssociationSuccessModal from "./associate-success-modal";
import AssociateHoneywellStep from "./honeywell-association";
import { credentialValidation, generateToken } from "../api/api";
import { notifyError } from "../../../../../ui/dls/dls-snackbar/dls-snackbar";
import DSSLoader from "../../../../../ui/building-blocks/atoms/dss-loader/dss-loader";
import { HoneywellAssociationData } from "../../model/model";
import { AssociateData } from "../../model/contant";

interface Props {
    onClose: () => void;
}

const AssociateHoneywellIdModal: React.FC<Props> = ({ onClose }) => {
    const [step, setStep] = useState(1);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [usernameError, setUsernameError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [stepperReady, setStepperReady] = useState(false);
 const [loading, setLoading] = useState(false);
    const [apiData, setApiData] = useState<HoneywellAssociationData | null>(null);
    const [apiError, setApiError] = useState<string | null>(null);
     const [accessToken, setAccessToken] = useState<string>("");

    const { translate } = useDssContext();

    const navigate = useNavigate();

    useEffect(() => {
        const timeout = setTimeout(() => setStepperReady(true), 0);
        return () => clearTimeout(timeout);
    }, []);

    useEffect(() => {
        let isMounted = true;
        const fetchToken = async () => {
            try {
                setLoading(true);
                const tokenResponse = await generateToken();
                if (isMounted) {
                    setAccessToken(tokenResponse.access_token || "");
                }
            } catch (err: any) {
                notifyError(err);
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };
        fetchToken();
        return () => {
            isMounted = false;
        };
    }, []);
    const handleNext = async() => {
        let valid = true;
        setUsernameError("");
        setPasswordError("");
        if (!username.trim()) {
            setUsernameError("User Name/Email is required");
            valid = false;
        }
        if (!password.trim()) {
            setPasswordError("Password is required");
            valid = false;
        }
      if (!valid) return;

       setLoading(true);
        try {
            const response = await credentialValidation({
                userName: username,
                password: password,
            }, accessToken);
            setApiData(response);
            setStep(2);
        } catch (err: any) {
            notifyError(err);
            
        } finally {
            setLoading(false);
        }
    };

    

    return (

        <div className="create-honeywell-modal-content">
            {loading&&<DSSLoader id="honeywell-loader" />}
            <div className="create-honeywell-modal-title">{translate('honeywellLoginIdAssociation')}</div>

            <div style={{ width: "100%", margin: "0 auto" }}>
                {stepperReady && (
                    <Stepper
                        stepConfig={[
                            { name: "Authentication", Component: () => <></> },
                            { name: "Association", Component: () => <></> },
                        ]}
                        incrementStep={step}
                    />
                )}
            </div>
            {
                step === 1 &&
                <div>
                    <div className="associate-auth-info">
                        {translate('pleaseEnterYourJeppesenCredentials')}
                    </div>
                    <div className="create-honewell-row">
                        <div className="create-honewell-input-col">
                            <DSSTextInput
                                id="associate-username"
                                label="User Name/Email"
                                value={username}
                                onChange={e => setUsername(e.target.value)}
                                className={usernameError ? 'create-honeywell-input-error' : 'create-honeywell-input'}
                            />
                            {usernameError && <div className="create-honeywell-error">{usernameError}</div>}
                        </div>
                    </div>
                    <div className="create-honewell-row">
                        <div className="create-honewell-input-col">
                            <DSSTextInput
                                id="associate-password"
                                label="Password"
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                className={passwordError ? 'create-honeywell-input-error' : 'create-honeywell-input'}
                            />
                            {passwordError && <div className="create-honeywell-error">{passwordError}</div>}
                        </div>
                    </div>
                    <div className="create-honeywell-divider" />
                    <div className="create-honeywell-modal-actions-row">
                        <div className="create-honeywell-support-info">
                            {translate('ifYouAreFacingAnyIssues')}&nbsp;
                            <DSSButton
                                variant="secondary"
                                className="create-honeywell-support-link"
                                type="button"
                                onClick={() => {
                                    onClose();
                                    navigate("/prelogin/support/customerSupport");
                                }}
                                id=""
                            >
                                {translate('here')}
                            </DSSButton>.
                        </div>
                        <div className="create-honeywell-modal-actions">
                            <DSSButton variant="secondary" onClick={onClose} id="">{translate('cancel')}</DSSButton>
                            <DSSButton variant="primary" style={{ marginLeft: 12 }} onClick={handleNext} id="">
                                {translate('next')}
                            </DSSButton>
                        </div>
                    </div>
                </div>}{
                step === 2 &&
                <AssociateHoneywellStep
                    data={apiData as HoneywellAssociationData}
                    accessToken={accessToken}
                    onBack={() => setStep(1)}
                    onClose={onClose}
                    onSupport={() => {
                        onClose();
                        navigate("/prelogin/support/customerSupport");
                    }}
                />
            }
            
        </div>
    );
};

export default AssociateHoneywellIdModal;